module.exports = __webpack_public_path__ + "media/signup-react/money-small-8b90f5e5.png";